import React from "react";
import Hamburger from "./Hamburger";
import HomeButton from "./HomeButton";
import Search from "./Search";

class Navigation extends React.Component {
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = () => {
        if (window.scrollY > 100) {
            document.querySelector('nav').classList.add('shrink');
        } else {
            document.querySelector('nav').classList.remove('shrink');
        }
    };

    render() {
        return (
            <nav>
                <div className="nav-left">
                    <Hamburger />
                    <HomeButton />
                </div>
                <div className="nav-search">
                    <Search />
                </div>
            </nav>
        );
    }
}

export default Navigation;
